import React, { useState } from "react";
import "./FAQ.css";

const leftColumn = [
  {
    question: "How do I know how much paint I need?",
    answer:
      "Use our Paint Calculator to get an accurate estimate based on your wall size and number of coats. This ensures you buy just the right amount without wastage.",
  },
  {
    question: "Do I need to apply primer before painting?",
    answer:
      "Use our Paint Calculator to get an accurate estimate based on your wall size and number of coats. This ensures you buy just the right amount without wastage.",
  },
];

const rightColumn = [
  {
    question: "How many coats of paint are recommended?",
    answer:
      "Use our Paint Calculator to get an accurate estimate based on your wall size and number of coats. This ensures you buy just the right amount without wastage.",
  },
  {
    question: "How long does Glamur Paint take to dry?",
    answer:
      "Use our Paint Calculator to get an accurate estimate based on your wall size and number of coats. This ensures you buy just the right amount without wastage.",
  },
  {
    question: "Are Glamur Paints eco-friendly?",
    answer:
      "Use our Paint Calculator to get an accurate estimate based on your wall size and number of coats. This ensures you buy just the right amount without wastage.",
  },
];

const FAQ = () => {
  // ✅ Set first question (left column index 0) as open by default
  const [activeIndex, setActiveIndex] = useState("L0");

  const toggleFAQ = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };

  const renderFAQItem = (item, index, columnPrefix) => (
    <div
      key={columnPrefix + index}
      className={`faq-item ${
        activeIndex === columnPrefix + index ? "active" : ""
      }`}
      onClick={() => toggleFAQ(columnPrefix + index)}
    >
      <div className="faq-question">
        <span className="faq-icon">
          {activeIndex === columnPrefix + index ? "–" : "+"}
        </span>
        <h3>{item.question}</h3>
      </div>
      {activeIndex === columnPrefix + index && item.answer && (
        <p className="faq-answer">{item.answer}</p>
      )}
    </div>
  );

  return (
    <section className="faq-section">
      <h2 className="faq-title">Frequently Ask Questions</h2>
      <div className="faq-columns">
        <div className="faq-column">
          {leftColumn.map((item, i) => renderFAQItem(item, i, "L"))}
        </div>
        <div className="faq-column">
          {rightColumn.map((item, i) => renderFAQItem(item, i, "R"))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;
